/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { agentMemorySuggestionControllerFindAll } from "./agentMemorySuggestionControllerFindAll";
import { agentMemorySuggestionControllerUpdate } from "./agentMemorySuggestionControllerUpdate";

export function agentMemorySuggestionsService() {
  return { agentMemorySuggestionControllerFindAll, agentMemorySuggestionControllerUpdate }
}